import { render } from "./CV.vue?vue&type=template&id=9995b0ea&scoped=true"
import script from "./CV.vue?vue&type=script&lang=js"
export * from "./CV.vue?vue&type=script&lang=js"

import "./CV.vue?vue&type=style&index=0&id=9995b0ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9995b0ea"

export default script